import { useState } from "react";
import API from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import DateInput from "../DateInput";

/* Quick reschedule for one sub-job from the day plan */
export default function SubJobTimeDialog({ item, onOpenChange, onSaved }) {
  const [f, setF] = useState({ start_date: item?.start_date || "", start_time: item?.start_time || "", end_time: item?.end_time || "" });
  const [saving, setSaving] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    if (!f.start_date) { toast.error("Pick a visit date"); return; }
    if (f.start_time && f.end_time && f.end_time <= f.start_time) { toast.error("End time must be after the start time"); return; }
    setSaving(true);
    try {
      await API.put(`/jobs/${item.id}`, { start_date: f.start_date, end_date: f.start_date, start_time: f.start_time, end_time: f.end_time });
      toast.success(`${item.reference} rescheduled`);
      onSaved?.(); onOpenChange(false);
    } catch (err) { toast.error(err?.response?.data?.detail || "Could not save"); }
    finally { setSaving(false); }
  };
  const clear = async () => {
    setSaving(true);
    try {
      await API.put(`/jobs/${item.id}`, { start_date: "", end_date: "", start_time: "", end_time: "" });
      toast.success(`${item.reference} moved to unscheduled`); onSaved?.(); onOpenChange(false);
    } catch (err) { toast.error(err?.response?.data?.detail || "Could not save"); }
    finally { setSaving(false); }
  };
  return (
    <Dialog open={!!item} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm" data-testid="sub-job-time-dialog">
        <form onSubmit={save} className="space-y-4">
          <DialogHeader>
            <DialogTitle className="font-[Chivo] text-base">{item?.sub_job_index ? `${item.sub_job_index}. ` : ""}{item?.title}</DialogTitle>
            <DialogDescription>{item?.reference}{item?.assignee ? ` · ${item.assignee}` : " · Unassigned"}</DialogDescription>
          </DialogHeader>
          <div className="space-y-1">
            <Label className="text-xs">Visit date</Label>
            <DateInput value={f.start_date} onChange={(e) => setF({ ...f, start_date: e.target.value })} testid="sub-job-time-date" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1"><Label className="text-xs">Arrive</Label><Input type="time" value={f.start_time} onChange={(e) => setF({ ...f, start_time: e.target.value })} data-testid="sub-job-time-start" /></div>
            <div className="space-y-1"><Label className="text-xs">Leave by</Label><Input type="time" value={f.end_time} onChange={(e) => setF({ ...f, end_time: e.target.value })} data-testid="sub-job-time-end" /></div>
          </div>
          <DialogFooter className="flex-row justify-between sm:justify-between">
            <Button type="button" variant="ghost" size="sm" className="text-muted-foreground" onClick={clear} disabled={saving} data-testid="sub-job-time-clear">Unschedule</Button>
            <div className="flex gap-2">
              <Button type="button" variant="outline" size="sm" onClick={() => onOpenChange(false)}>Cancel</Button>
              <Button type="submit" size="sm" disabled={saving} data-testid="sub-job-time-save">{saving ? "Saving…" : "Save"}</Button>
            </div>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
